'use strict';

import mapboxgl from 'mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import MapboxLanguage from '@mapbox/mapbox-gl-language';

window.TWER_MAPBOX = {
  mapboxgl : mapboxgl,
  MapboxGeocoder : MapboxGeocoder,
  MapboxLanguage : MapboxLanguage
};
